import axios from "axios";
import { config } from "../../utils/constants";
import { getCurrentLocale, isLiferayEnv } from "../../utils/util";
import { oAuthRequest } from "../../utils/request";


export const getQuestionForBaraem = (id) => {
  const env = isLiferayEnv();
  const locale = getCurrentLocale();
  let requestBody = {
    id: id,
    locale: locale
  };


  const requestConfig = {
    method: "POST",
    url: `${config.baraemServices}getBaraemQuestions`,
    data: requestBody
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const saveBaraemAnswersRequest = async (requestData) => {
  const env = isLiferayEnv();
  let data = { ...requestData, isLiferay: env };


  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}saveBaraemAnswer`,

    data: data
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const saveBaraemAnswersKeyMatrixRequest = (requestData) => {
  const env = isLiferayEnv();

  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}saveBaraemAnswerKeyMatrix`,

    data: requestData
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};
export const addChild = async (requestData) => {
  const env = isLiferayEnv();
  let data = { ...requestData, isLiferay: env };

  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}addChild`,
    data
  };

  try {
    if (env) {
      return oAuthRequest(requestConfig);
    } else {
      return await axios.request(requestConfig);
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    }
    console.error("Unexpected Error adding child:", error);
    throw error;
  }
};


export const getpickListData = (id) => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}getpickListData/${id}`,
    data: id
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getAllChild = async () => {
  const env = isLiferayEnv();
  const requestConfig = {
    method: 'GET',
    url: `${config.baraemServices}getAllChild`,
    params: {
      env
    }
  };

  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getAssessmentDetails = () => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}getAssessment`
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

// export const getChildDetailsByMrn = (id) => {
//     const env = isLiferayEnv();
//
//     const requestConfig = {
//         url: `${config.baraemServices}search-by-mrn/${id}`,
//     };
//     if (env) {
//         return oAuthRequest(requestConfig)
//     }
//     return axios.request(requestConfig);
// }

export const createAndSendOtp = (mobileNo) => {
  const env = isLiferayEnv();

  let cleanMobileNo = mobileNo.replace(/\+/g, "");
  let requestBody = {
    mobileNo: cleanMobileNo
  };
  const requestConfig = {
    method: "POST",
    url: `${config.baraemServices}generate-otp`,
    data: requestBody
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }

  return axios.request(requestConfig);
};

export const verifyOtp = (otp, uuid, mrn) => {
  const env = isLiferayEnv();

  let requestBody = {
    otp: otp,
    uuid: uuid,
    mrn: mrn
  };
  const requestConfig = {
    method: "POST",
    url: `${config.baraemServices}verify-otp`,
    data: requestBody
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getParentInfoByMrn = () => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}parentInfo`
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const tbluserquestionnairestatuses = (requestData) => {
  const env = isLiferayEnv();

  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}addQuestionnaireStatus`,

    data: requestData
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }

  return axios.request(requestConfig);
};

export const getUserQuestionnairestatuses = (id) => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}getQuestionnaireStatus/${id}`,
    method: 'GET'


  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const updateQuestionnaireStatus = (id, requestData) => {
  const env = isLiferayEnv();

  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}updateQuestionnairestatus/${id}`,

    data: requestData
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }

  return axios.request(requestConfig);
};

export const updateChildProfile = async (requestData) => {
  const env = isLiferayEnv();
  let data = { ...requestData, isLiferay: env };


  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}updateChildProfile`,

    data: data
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getDownloadPdf = (data) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.baraemServices}downloadReport`,

    method: "POST",
    data
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);

};

export const getDependentDetails = () => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}dependent-details`,
    method: 'GET'
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const sendSmsForChildAdd = (mobileNumber, childName) => {
  const env = isLiferayEnv();

  let cleanMobileNo = mobileNumber.replace(/\+/g, "");
  let requestBody = {
    mobileNumber: cleanMobileNo,
    childName: childName
  };
  const requestConfig = {
    method: "POST",
    url: `${config.baraemServices}generateSmsForChildAdd`,
    data: requestBody
  };

  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const checkUserPresent = async (requestData) => {
  const env = isLiferayEnv();
  const locale = getCurrentLocale();
  let data = { ...requestData, isLiferay: env, locale: locale };


  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}getbaraemuserfind`,
    data: data

  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);

};

export const getDependentListData = async (requestData) => {
  const env = isLiferayEnv();
  const locale = getCurrentLocale();
  let data = { ...requestData, isLiferay: env, locale: locale };


  const requestConfig = {
    method: 'POST',
    url: `${config.baraemServices}getDependentList`,
    data: data

  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);

};

export const getDownloadBaraemReportPdf = (data) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.baraemServices}getBaraemReprotPdf`,

    method: "POST",
    data
  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);

};

export const getDetailsForChildFromFileNet = (id, username) => {
  const env = isLiferayEnv();

  const requestConfig = {
    url: `${config.baraemServices}getDetailsForChildFromFileNet/${id}/${username}`,
    method: 'GET'


  };
  if (env) {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};


export const getIdamUserDetails = () => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.baraemServices}userType`,
    method: "get",
    params: {
      env
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};